import { Subject } from 'rxjs';

const subject = new Subject();

export const SubmitButtonService = {
  loadStart: () => subject.next( false ),
  clearLoading: () => subject.next(true),
  getLoading: () => subject.asObservable()
};